import { React, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DrawerAppBarMain from "./navbar";
import { Box, Button, Typography } from "@mui/material";
import Img1 from "../../images/main1.png";
import Img2 from "../../images/main2.png";
import GP from "../../images/GPmain.png";
import AS from "../../images/ASmain.png";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import LandingCard from "./landingCard";
import Img3 from "../../images/main2-1.png";
import Img4 from "../../images/main2-2.png";
import Img5 from "../../images/main2-3.png";
import Img6 from "../../images/main2-4.png";
import Img7 from "../../images/main2-5.png";
import Img8 from "../../images/main3.png";
import Img9 from "../../images/main3-2.png";
import Img10 from "../../images/main4.png";
import Img11 from "../../images/main5.png";
import LogoImg from "../../images/logo 01.png";

export default function Landing() {
  let width = window.innerWidth;
  const imageSrc = width > 500 ? Img1 : Img2;
  const checkElevation = width > 900 ? 7 : 0;
  const setImg = width > 900 ? Img8 : Img9;
  // let bool=true;
  // useEffect(() => {
  //   while (bool){
  //     bool=false;
  //     window.location.reload();
  //   }
  // }, []);
  return (
    <div className="Landing">
      <DrawerAppBarMain />
      <Box sx={{ padding: "8rem 2rem 0rem", mt: "2rem" }} id="Home">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: "3.8rem",
              fontWeight: "700",

              lineHeight: "4.8rem",
              mb: "13px",
              "@media (min-width:900px)": {
                maxWidth: "65vw",
              },
              "@media (max-width:900px)": {
                fontSize: "2.3rem",
                lineHeight: "2.5rem",
              },
            }}
          >
            Revolutionize the way you pay and get paid with Blockpay
          </Typography>
          <Typography
            sx={{
              color: "#666666",
              fontWeight: "500",
              fontSize: "1.125rem",
              mb: "1.4rem",
            }}
          >
            Manage all your crypto payments and transactions seamlessly with
            Blockpay.
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Box
          component="img"
          src={GP}
          sx={{
            height: "5rem!important",
            width: "auto",
            "@media (max-width:500px)": {
              width: "50%",
            },
          }}
        />
        <Box
          component="img"
          src={AS}
          sx={{
            height: "5rem!important",
            width: "auto",
            "@media (max-width:500px)": {
              width: "50%",
            },
          }}
        />
      </Box>
      <Box
        component="img"
        src={imageSrc}
        sx={{
          width: "100%",
          height: "auto",
          mt: 2,
        }}
      />
      <Box
        sx={{
          background:
            "linear-gradient(180deg, #F8F8F8 0%, #F8F8F8 100%)!important",
          padding: "4rem 9rem!important",
          "@media (max-width:600px)": {
            padding: "1.5rem 2rem!important",
          },
        }}
        id="Features"
      >
        <Grid container spacing={3}>
          <Grid item xs={12} md={7} lg={9}>
            <Typography
              sx={{
                color: "#666666",
                fontSize: "1.9rem",
                fontWeight: "500",
                textAlign: "left",
                paddingBottom: "15px",
                marginTop: "8%",
              }}
            >
              Feature
            </Typography>
            <Typography
              sx={{
                color: "#111111",
                fontSize: "3vw",
                fontWeight: "700",
                textAlign: "left",
                lineHeight: "55px",
                "@media (max-width:900px)": {
                  fontSize: "2.3rem",
                  lineHeight: "2.5rem",
                },
              }}
            >
              Our Distinguishing
              <br /> Qualities
            </Typography>
          </Grid>
          <Grid item xs={12} md={5} lg={3}>
            <LandingCard
              img={Img3}
              head="Customize Payment Option"
              content="Customize payment options and branding for your business."
            />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <LandingCard
              img={Img4}
              head="Accept Payments Locally"
              content="Accept digital currency payments from customers across South Africa."
            />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <LandingCard
              // elevation={checkElevation}
              img={Img5}
              head="Manage Payment & Transaction"
              content="Manage your payments and transactions in one centralized dashboard."
            />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <LandingCard
              img={Img6}
              head="Receive Local Currency"
              content="Receive settlements in South African Rands (ZAR)."
            />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <LandingCard
              img={Img7}
              head="Setup Payment & Subscription"
              content="Set up recurring payments and subscriptions."
            />
          </Grid>
        </Grid>
      </Box>
      <Box
        sx={{
          background: "#ffffff",
          padding: "4rem 9rem!important",
          "@media (max-width:600px)": {
            padding: "1.5rem 2rem!important",
          },
        }}
        id="How It Works"
      >
        <Grid container spacing={3}>
          <Grid item xs={12} md={12} lg={6}>
            <Typography
              sx={{
                color: "#666666",
                fontSize: "1.7rem",
                fontWeight: "500",
                textAlign: "left",
                paddingBottom: "10px",
              }}
            >
              Benefit
            </Typography>
            <Typography
              sx={{
                color: "#111111",
                fontSize: "2.7vw",
                fontWeight: "700",
                textAlign: "left",
                lineHeight: "55px",
                mb: "!rem",
                "@media (max-width:900px)": {
                  fontSize: "2.3rem",
                  lineHeight: "2.5rem",
                },
              }}
            >
              What works in
              <br /> our favor
            </Typography>
            <Box
              sx={{ borderBottom: "solid 0.5px #696969", paddingTop: "2.5rem" }}
            >
              <Typography
                sx={{
                  textAlign: "left",
                  fontWeight: "600",
                  fontSize: "1.3rem",
                  mb: "3px",
                }}
              >
                Accept Payments from Anyone across South Africa.
              </Typography>
              <Typography
                sx={{
                  textAlign: "left",
                  fontWeight: "500",
                  fontSize: "1rem",
                  color: "#696969",
                  mb: "1rem",
                }}
              >
                Expand your customer base and accept payments from anyone, anywhere in South Africa.
              </Typography>
            </Box>
            <Box
              sx={{ borderBottom: "solid 0.5px #696969", paddingTop: "1rem" }}
            >
              <Typography
                sx={{
                  textAlign: "left",
                  fontWeight: "600",
                  fontSize: "1.3rem",
                  mb: "3px",
                }}
              >
                Streamline Payment Process
              </Typography>
              <Typography
                sx={{
                  textAlign: "left",
                  fontWeight: "500",
                  fontSize: "1rem",
                  color: "#696969",
                  mb: "1rem",
                }}
              >
                Streamline your payment process with a comprehensive dashboard.
              </Typography>
            </Box>
            <Box
              sx={{ borderBottom: "solid 0.5px #696969", paddingTop: "1rem" }}
            >
              <Typography
                sx={{
                  textAlign: "left",
                  fontWeight: "600",
                  fontSize: "1.3rem",
                  mb: "3px",
                }}
              >
                Minimize Currency Conversion Fees
              </Typography>
              <Typography
                sx={{
                  textAlign: "left",
                  fontWeight: "500",
                  fontSize: "1rem",
                  color: "#696969",
                  mb: "1rem",
                }}
              >
                Minimize currency conversion fees and receive settlements in
                your preferred currency
              </Typography>
            </Box>
            <Box
              sx={{ borderBottom: "solid 0.5px #696969", paddingTop: "1rem" }}
            >
              <Typography
                sx={{
                  textAlign: "left",
                  fontWeight: "600",
                  fontSize: "1.3rem",
                  mb: "3px",
                }}
              >
                Set up Automated Payments
              </Typography>
              <Typography
                sx={{
                  textAlign: "left",
                  fontWeight: "500",
                  fontSize: "1rem",
                  color: "#696969",
                  mb: "1rem",
                }}
              >
                Set up automated payments and subscriptions for recurring
                revenue.
              </Typography>
            </Box>
            <Box sx={{ paddingTop: "1rem" }}>
              <Typography
                sx={{
                  textAlign: "left",
                  fontWeight: "600",
                  fontSize: "1.3rem",
                  mb: "3px",
                }}
              >
                Enhance Customer Experience
              </Typography>
              <Typography
                sx={{
                  textAlign: "left",
                  fontWeight: "500",
                  fontSize: "1rem",
                  color: "#696969",
                  mb: "1rem",
                }}
              >
                Enhance your brand image and customer experience with customized
                payment options and branding.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={12} lg={3}>
            <Box
              component="img"
              src={setImg}
              sx={{
                width: "39vw",
                "@media (max-width:900px)": { width: "100%" },
              }}
            />
          </Grid>
        </Grid>
      </Box>
      <Box
        component="img"
        src={Img10}
        id="Subscribe"
        sx={{
          width: "100%",
          height: "auto",
        }}
      />
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <Box
          component="img"
          src={LogoImg}
          sx={{ height: "2.5rem", mb: "2rem" }}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            textAlign: "justify",
          }}
        >
          <Box
            component={Link}
            sx={{
              margin: "1rem 1rem",
              textDecoration: "None",
              color: "Black",
              "@media (max-width:600px)": { margin: "0.5rem 0.5rem" },
            }}
          >
            Home
          </Box>
          <Box
            component={Link}
            sx={{
              margin: "1rem 1rem",
              textDecoration: "None",
              color: "Black",
              "@media (max-width:600px)": { margin: "0.5rem 0.5rem" },
            }}
          >
            Information
          </Box>
          <Box
            component={Link}
            sx={{
              margin: "1rem 1rem",
              textDecoration: "None",
              color: "Black",
              "@media (max-width:600px)": { margin: "0.5rem 0.5rem" },
            }}
          >
            History
          </Box>
          <Box
            component={Link}
            sx={{
              margin: "1rem 1rem",
              textDecoration: "None",
              color: "Black",
              "@media (max-width:600px)": { margin: "0.5rem 0.5rem" },
            }}
          >
            Account
          </Box>
        </Box>
        <Box>
          <Box
            component={Link}
            sx={{
              margin: "1rem 1rem",
              textDecoration: "None",
              color: "Black",
              "@media (max-width:600px)": { margin: "0.5rem 0.5rem" },
            }}
          >
            Privacy Policy
          </Box>
          <Box
            component={Link}
            sx={{
              margin: "1rem 1rem",
              textDecoration: "None",
              color: "Black",
              "@media (max-width:600px)": { margin: "0.5rem 0.5rem" },
            }}
          >
            Legal
          </Box>
        </Box>
        <Box
          component="img"
          src={Img11}
          sx={{ height: "2rem", mt: "1rem", mb: "2rem" }}
        />
        <Typography sx={{ mb: "1rem" }}>
          © 2023 <strong>Blockpay</strong>. All Rights Recovered
        </Typography>
      </Box>
    </div>
  );
}
